/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import InputGroup from './InputGroup';
import { Box } from '@mui/material';
import api from 'services/api';

function Installments({ type, description }) {
  const {
    getFieldMeta, setFieldValue,
  } = useFormikContext();
  const { value: parts } = getFieldMeta('parts');
  const { value: billValue } = getFieldMeta('value');

  const [bankAccounts, setBankAccounts] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);

  // insere o valor total na primeira parcela
  useEffect(() => {
    if (parts.length === 1) {
      setFieldValue('parts.[0].value', billValue);
    }
  }, [billValue, parts.length, setFieldValue]);

  useEffect(() => {
    async function loadData() {
      try {
        const bankAccountsData = (await api.get('/bank-account')).data;
        const paymentTypesData = (await api.get('/payment-types')).data;
        setBankAccounts(bankAccountsData);
        setPaymentTypes(paymentTypesData);
      } catch (e) {
        throw new Error();
      }
    }
    loadData();
  }, []);

  const hasParts = parts && parts.length > 0;

  return (
    <FieldArray name="parts">
      <Box
        display="flex"
        flexDirection="column"
        rowGap={2}
      >
        {hasParts && (
          parts.map((_, index) => (
            <InputGroup
              key={index}
              index={index}
              bankAccounts={bankAccounts}
              paymentTypes={paymentTypes}
              type={type}
              description={description}
            />
          ))
        )}
      </Box>
    </FieldArray>
  );
}

export default Installments;
